import _extends from 'babel-runtime/helpers/extends';
import { getOptionProps, getListeners } from '../_util/props-util';
import Upload from './Upload';
import { UploadProps } from './interface';

export default {
  name: 'AUploadDragger',
  props: UploadProps,
  render: function render() {
    var h = arguments[0];

    var props = getOptionProps(this);
    var draggerProps = {
      props: _extends({}, props, {
        type: 'drag'
      }),
      on: getListeners(this),
      style: { height: this.height }
    };
    return h(
      Upload,
      draggerProps,
      [this.$slots['default']]
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/ant-design-vue@1.7.8/node_modules/ant-design-vue/es/upload/Dragger.js
// module id = null
// module chunks = 